/* eslint-disable new-cap */
import $ from 'jquery';
import Tingle from 'tingle.js';
import Base from '../../../_config/base';

class ThemesModal extends Base {
  constructor(el) {
    super(el);

    // Get jQuery object
    this.Themes = this.$el;

    let themesIsOpen = false;

    const Modal = new Tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'escape'],
      //closeLabel: "Close",
      cssClass: ['main-nav-modal', 'themes-list-modal'],
      onOpen: () => {
        themesIsOpen = true;
      },
      onClose: () => {
        themesIsOpen = false;
      },
      beforeClose: () => {
        // Some logic such as saving content before closing modal... etc ...
        return true; // close the modal (return false if you want the modal to stay open)
      },
    });

    const themesToggle = this.Themes.find('.themes-toggle');

    //let container = this.Themes;

    themesToggle.bind('click', (e) => {
      e.preventDefault();

      if (!themesIsOpen) {
        // Show navigation menu (modal)
        Modal.setContent($('.hidden-themes-content').html());

        const closeBtn = $('.main-nav-modal .main-nav-close');
        closeBtn.bind('click', (ev) => {
          ev.preventDefault();
          Modal.close();
        });

        Modal.open();
      } else {
        Modal.close();
      }
    });
  }
}
/* eslint-enable new-cap */

ThemesModal.className = 'ThemesModal';
export default ThemesModal;



// WEBPACK FOOTER //
// ./src/materials/molecules/themes-modal/themes-modal.js